import './TextFilterForm.css';
import * as React from 'react';
import { t } from 'i18next';

const TextFilterForm = (label, inputRequired) => ({ updateCurrent, current }) => (
  <div className="TextFilterForm">
    {inputRequired ? (
      <p className="showError">
        {t('filters.label.warning', {
          value: label,
        })}
        {' '}
      </p>
    ) : ''}
    <input type="text"
      placeholder={t(`filters.label.${label}`)}
      defaultValue={current}
      onChange={e => updateCurrent(e.target.value)}
    />
  </div>
);

export default TextFilterForm;
